<template>
  <b-tab title="Extrato PF" @click="onBonusTabClick()">
    <b-col lg="6" class="my-1">
      <b-row>
        <b-form-radio-group
                v-model="userRadioBonusSelected"
                buttons
        >
          <b-form-radio value="user" v-b-tooltip.hover title="Usuário Responsável">Usuário</b-form-radio>
          <b-form-radio value="cod" v-b-tooltip.hover title="Código">Código</b-form-radio>
          <b-form-radio value="name" v-b-tooltip.hover title="Nome">Nome</b-form-radio>
        </b-form-radio-group>
        <b-input-group size="sm" style="{padding-top: 10px; margin-top: 10px;}">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input v-model="filterUserBonusText" v-on:keyup.enter="onUserBonusSearchClick()" type="search" placeholder="Buscar..."></b-form-input>
        </b-input-group>
      </b-row>
    </b-col>
    <b-table striped :fields="userFields" :current-page="currentPage"  :items="users" :per-page="0" stacked="md">
      <template v-slot:cell(info)="row">
        <b-row>
          <b-button class="item-table" @click="onInfoClick(row.item, row.index, $event.target)">+</b-button>
        </b-row>
      </template>
    </b-table>
    <b-col sm="7" md="6" class="my-1">
      <b-pagination
              @input ="updateBonusPage()"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
      ></b-pagination>
    </b-col>
    <b-modal
            id="modal-prevent-closing"
            ref="corporateModal"
            ok-title="Ok"
            cancel-variant="transparent"
            :title="corporateModalTitle"
            @hidden="resetCorporateModal"
            @ok="handleCorporateModalOk"
            size="xl"
    >
      <b-form v-on:submit.prevent>
        <b-row>
          <b-col>
            <b-form-group label="Data inicial" label-for="date-input">
              <b-form-datepicker id="example-datepicker" v-model="selectedBeginDate" v-on:input="onDateChange()" v-bind="labels[locale] || {}" reset-button :locale="locale"></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Data final" label-for="date-input">
              <b-form-datepicker id="example-datepicker2" v-model="selectedFinalDate" v-on:input="onDateChange()" v-bind="labels[locale] || {}" reset-button :locale="locale"></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col>
            <h5 style="font-size:10">Total <b-badge class="badge">{{statementTotal}}</b-badge></h5>
            <download-csv @export-started="generateDataToExport()" ref="csvExporter"
                    :name="statementCsvTitle"
            />
          </b-col>
          <b-col>
            <div>
              <b-form-radio-group
                      v-model="selected"
                      buttons
              >
                <b-form-radio value="user" v-b-tooltip.hover title="Usuário Responsável">Usuário</b-form-radio>
                <b-form-radio value="cod" v-b-tooltip.hover title="Código">Código</b-form-radio>
                <b-form-radio value="description" v-b-tooltip.hover title="Descrição da auditoria">Descrição</b-form-radio>
                <b-form-radio value="type" v-b-tooltip.hover title="Tipo da transação">Tipo</b-form-radio>
                <b-form-radio value="api" v-b-tooltip.hover title="Nome do token">Api</b-form-radio>
                <b-form-radio value="duration" v-b-tooltip.hover title="Duração da transação">Duração</b-form-radio>
              </b-form-radio-group>
              <div>
                <b-input-group size="sm" style="{padding-top: 10px; margin-top: 10px;}">
                  <b-input-group-prepend is-text>
                    <b-icon icon="search"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input v-model="filterText" v-on:keyup.enter="onStatementSearchClick()" type="search" placeholder="Buscar..."></b-form-input>
                </b-input-group>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-table responsive striped :fields="statementFields" :items="statements" @sort-changed="sortChanged" :per-page="0" :current-page="currentStatementPage" style="{ max-height: 300px !important; height: 300px !important; overflow-y: scroll}">
          </b-table>
          <b-row>
            <b-col class="my-3">
          <b-pagination
                  @input ="updatePage()"
                  v-model="currentStatementPage"
                  :total-rows="totalStatementRows"
                  :per-page="perStatementPage"
                  align="fill"
                  size="sm"
                  class="my-0"
          ></b-pagination>
            </b-col>
          <b-col  class="my-3">
            <b-form-select
                    id="per-page-select"
                    v-model="perStatementPage"
                    :options="pageOptions"
                    @input ="updatePage()"
            ></b-form-select>
          </b-col>
          </b-row>
        </b-row>
      </b-form>
    </b-modal>
  </b-tab>
</template>

<script>
  import { userService } from '../../services/user_service';
  import { storeService } from '../../services/store.service';
  import { formatingSecondToDate } from '../../helpers/server';
  import moment from 'moment';
  import JsonCSV from '../Export/JsonCSV.vue';

  export default {
    components: {
      'download-csv': JsonCSV
    },
    data () {
      return {
        tabType: '',
        perPage: 15,
        currentPage: 1,
        filterText: '',
        isLoading: false,
        isAdmin: false,
        activeUsers: 0,
        totalStatementRows: 0,
        pageOptions: [5, 10, 15, { value: 100, text: 'Mostrar 100' }],
        statementTotal: 0,
        inactiveUsers: 0,
        statementModalLoaded: false,
        selectedBeginDate: null,
        selectedFinalDate: null,
        selected: 'user',
        statements: [],
        users: [],
        totalRows: 1,
        perStatementPage: 10,
        userRadioBonusSelected: 'user',
        corporateModalTitle: 'Extrato',
        currentStatementPage: 1,
        filterUserBonusText: '',
        corporateId: 0,
        accountId: 0,
        statementCsvTitle: 'CSV',
        accountLogin: '',
        adminInfoLoaded: true,
        statementFields: [
          { key: 'login', label: 'Usuário' },
          { key: 'statementId', label: 'Cód', sortable: true },
          { key: 'observation', label: 'Descrição', sortable: true, thStyle: { width: '370px' } },
          {
            key: 'transactionType',
            label: 'Tipo',
            sortable: true,
            formatter: (value, key, item) => {
              return value === 'D' ? 'Débito' : 'Crédito';
            },
            thStyle: { width: '110px' }
          },
          {
            key: 'created',
            label: 'Data',
            sortable: true,
            formatter: (value, key, item) => {
              return moment.unix(value).format('DD/MM/YYYY');
            },
            thStyle: { width: '120px' }
          },
          {
            key: 'tokenName',
            label: 'API',
            sortable: false,
            thStyle: { width: '150px' }
          },
          {
            key: 'mediaLength',
            label: 'Duração',
            sortable: false,
            formatter: (value, key, item) => {
              return new Date(value * 1000).toISOString().substring(11, 19);
            },
            thStyle: { width: '110px' }
          }
        ],
        locale: 'pt-BR',
        labels: {
          'pt-BR': {
            labelPrevDecade: 'Década anterior',
            labelPrevYear: 'Ano passado',
            labelPrevMonth: 'Mês passado',
            labelCurrentMonth: 'Mês atual',
            labelNextMonth: 'Próximo mês',
            labelNextYear: 'Próximo ano',
            labelNextDecade: 'Próxima década',
            labelToday: 'Hoje',
            labelSelected: 'Data selecionada',
            labelNoDateSelected: 'Selecione uma data',
            labelCalendar: 'Calendário',
            labelNav: 'Navegação do calendário',
            labelHelp: 'Navegue pelo calendário com as teclas de seta'
          }
        },
        userFields: [
          { key: 'accountId', label: 'Cód', sortable: true },
          { key: 'name', label: 'Nome', sortable: true },
          { key: 'login', label: 'Login', sortable: true, thStyle: { width: '130' } },
          {
            key: 'userCredits.credits',
            label: 'Créditos Disponíveis',
            sortable: false,
            formatter: (value, key, item) => {
              return formatingSecondToDate(value);
            },
            thStyle: { width: '130' }
          },
          {
            key: 'created',
            label: 'Data',
            sortable: true,
            formatter: (value, key, item) => {
              return moment.unix(value).format('DD/MM/YYYY');
            },
            thStyle: { width: '180px' }
          },
          { key: 'info', label: 'Info', sortable: false, thStyle: { width: '150px' } }
        ]
      };
    },
    watch: {
      filterText (newValue) {
        this.filterText = newValue.replace(/[^\p{L}\p{N}\s()]/gu, '');
      }
    },
    methods: {
      async onBonusTabClick () {
        this.tabType = 'user';
        await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: 1, adminTab: 'extratoPF' });
      },
      async loadUserAdminInfo (params) {
        this.isLoading = true;
        const result = await userService.userAdminInfo(params);
        if (result && result.length > 0) {
          this.isAdmin = true;
          this.activeUsers = result[1] ? result[1].active : this.activeUsers;
          this.inactiveUsers = result[2] ? result[2].nonActive : this.inactiveUsers;

          const usersFilter = result[0].elements.filter((user) => !user.corporateId);
          this.users = usersFilter;

          this.pageInfo = result[0].pageInfo;
          this.totalRows = this.pageInfo && this.pageInfo.length > 0 && this.pageInfo[0].count;
        }
        this.isLoading = false;
      },
      async onUserBonusSearchClick () {
        if (this.adminInfoLoaded) {
          if (this.userRadioBonusSelected === 'user' && this.filterUserBonusText.length > 2) {
            await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage), user: this.filterUserBonusText.trim().toLowerCase() });
          } else if (this.userRadioBonusSelected === 'cod') {
            await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage), accountId: this.filterUserBonusText.trim() });
          } else if (this.userRadioBonusSelected === 'name' && this.filterUserBonusText.length > 1) {
            await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage), name: this.filterUserBonusText.trim() });
          } else {
            await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage) });
          }
        }
      },
      sortChanged (e) {
        if (this.statementModalLoaded) {
          this.loadStatements({
            perPage: parseInt(this.perStatementPage),
            currentPage: this.currentStatementPage,
            sortBy: e.sortBy,
            sortDesc: e.sortDesc
          });
        }
      },
      async onInfoClick (item, index, target) {
        this.pageInfo = null;
        this.totalStatementRows = null;
        this.statementTotal = null;
        if (item.corporate) {
          this.corporateId = item.corporate.corporateId;
        } else {
          this.corporateId = null;
          this.accountId = item.accountId;
          this.accountLogin = item.login;
          this.statementCsvTitle = this.accountLogin + '.csv';
        }
        await this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), type: 'info' });
        this.statementModalLoaded = true;
        this.$refs.corporateModal.show();
      },
      async updateBonusPage () {
        if (this.userRadioBonusSelected === 'user' && this.filterUserBonusText.length > 2) {
          await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage), user: this.filterUserBonusText.trim().toLowerCase() });
        } else if (this.userRadioBonusSelected === 'cod') {
          await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage), accountId: this.filterUserBonusText.trim() });
        } else if (this.userRadioBonusSelected === 'name' && this.filterUserBonusText.length > 1) {
          await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage), name: this.filterUserBonusText.trim() });
        } else {
          await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage) });
        }
      },
      async loadStatements (params) {
        const result = this.tabType === 'corp'
          ? await storeService.extractByCorporate(this.corporateId, params)
          : await userService.statementUserCreditInfo(this.accountId, params);
        this.statements = [];
        if (result && result.length > 0) {
          this.statements = result[0].elements;
          this.pageInfo = result[0].pageInfo;
          this.totalStatementRows = this.pageInfo && this.pageInfo.length > 0 && this.pageInfo[0].count;
        }
        let total = 0;
        for await (const statement of this.statements) {
          total += statement.mediaLength;
          if (this.tabType === 'user') {
            statement.login = this.accountLogin;
          }
        }
        this.statementTotal = new Date(total * 1000).toISOString().substring(11, 19);
      },
      resetCorporateModal () {
        this.selectedBeginDate = null;
        this.selectedFinalDate = null;
        this.statements = [];
        this.statementModalLoaded = false;
      },
      handleCorporateModalOk (bvModalEvent) {

      },
      onDateChange () {
        if (this.selectedBeginDate && this.selectedFinalDate) {
          this.onStatementSearchClick();
        }
      },
      onStatementSearchClick () {
        if (this.statementModalLoaded) {
          const date = this.filterCreatedDate();
          if (this.selected === 'user' && this.filterText.length > 2) {
            this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), user: this.filterText.toLowerCase(), date: date });
          } else if (this.selected === 'cod') {
            this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), statementId: this.filterText, date: date });
          } else if (this.selected === 'description' && this.filterText.length > 1) {
            this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), observation: this.filterText, date: date });
          } else if (this.selected === 'type') {
            this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), transactionType: this.filterText.toUpperCase(), date: date });
          } else if (this.selected === 'duration') {
            this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), mediaLength: this.filterText.toLowerCase(), date: date });
          } else if (this.selected === 'api') {
            this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), tokenName: this.filterText.toLowerCase(), date: date });
          } else {
            this.loadStatements({ perPage: parseInt(this.perStatementPage), currentPage: parseInt(this.currentStatementPage), date: date });
          }
        }
      },
      async generateDataToExport () {
        const date = this.filterCreatedDate();
        const params = {
          perPage: 9999,
          currentPage: 1,
          date: date,
          type: 'export'
        };
        if (this.selected === 'user' && this.filterText.length > 2) {
          Object.assign(params, { user: this.filterText.toLowerCase() });
        } else if (this.selected === 'cod') {
          Object.assign(params, { statementId: this.filterText });
        } else if (this.selected === 'description' && this.filterText.length > 1) {
          Object.assign(params, { observation: this.filterText });
        } else if (this.selected === 'type') {
          Object.assign(params, { transactionType: this.filterText.toUpperCase() });
        } else if (this.selected === 'api') {
          Object.assign(params, { tokenName: this.filterText.toLowerCase() });
        } else if (this.selected === 'duration') {
          Object.assign(params, { mediaLength: this.filterText.toLowerCase() });
        }
        const result = this.tabType === 'corp'
          ? await storeService.extractByCorporate(this.corporateId, params)
          : await userService.statementUserCreditInfo(this.accountId, params);
        if (this.tabType === 'user') {
          for await (const statement of result[0].elements) {
            statement.login = this.accountLogin;
          }
        }
        if (result && result.length > 0) {
          await this.$refs.csvExporter.export(result[0].elements);
        } else {
          return [];
        }
      },
      filterCreatedDate () {
        if (this.selectedBeginDate && this.selectedFinalDate) {
          const beginDate = moment(this.selectedBeginDate).unix();
          const finalDate = moment(this.selectedFinalDate).unix();
          return `${beginDate}|${finalDate}`;
        } else {
          return null;
        }
      }
    }
  };
</script>
